import React from 'react';

const PopularityStats = () => {
  const userTime = 150; // Example data: Time for a specific user
  const avgTime = 200;  // Average time per community
  const resourceUsage = 70; // Resource Usage for LGL Group

  const scoring = ((userTime / avgTime) * 100).toFixed(2); // Percentage-based scoring
  
  return (
    <div className="card">
      <h2>Popularity Stats & Resource Usage</h2>
      <div className="scoring">
        <p>Overall Scoring: {scoring}%</p>
        <p>Your Time: {userTime} minutes</p>
        <p>Community Average: {avgTime} minutes</p>
      </div>
      <div className="resource-usage">
        <p>Resource Usage (LGL Group): {resourceUsage}%</p>
        <p>Average Usage (All Groups): 65%</p>
      </div>
    </div>
  );
};

export default PopularityStats;
